<template>
<div >
    <v-toolbar flat color="white">
        <v-btn color="primary" dark class="mb-2" @click="newDialog=true; basicInformation=true; showAccessPoints=false;  cancelFields()" round >ADD ACCESS POINT GROUP</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

     <v-dialog persistent v-if="accessPointSearch" v-model="accessPointSearch" max-width="1000px">
      <accesspointsearchmodal
           @accessPointSelected="onAccessPointSelection"
           :multi="true"
           :preselected="selectedAccessPoints"
      ></accesspointsearchmodal>
    </v-dialog>

     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">

        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD ACCESS POINT GROUP</h1>
        </v-toolbar>

  <v-toolbar flat color="white">
        <v-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="basicInformation=true;showAccessPoints=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Basic Information</v-tab>
          <v-tab
            @click="basicInformation=false;showAccessPoints=true"
            class="grey--text"
            flat
            round
            color="grey"
          >Access Points</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat>
        <v-card flat v-show="basicInformation">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.description"
                    label="Description"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

               </v-layout>
            </v-container>
          </v-card-text>
            </v-card>

        <v-card flat v-show="showAccessPoints">
          <v-card-text>
            <v-toolbar flat class="white">
              <v-spacer></v-spacer>
             
              <v-btn  v-if="this.selectedAccessPoints.length==0" 
                class="primary" flat round
                @click="accessPointSearch=true ; selectedAccessPoints=[]"
              >Add Access Points</v-btn>
                   <v-btn v-if="this.selectedAccessPoints.length>0" flat round class="primary" @click="accessPointSearch=true ">Edit Access Points</v-btn>          
            </v-toolbar>
            <v-data-table  v-if="this.selectedAccessPoints.length>0" 
              :headers="headers2"
              :items="selectedAccessPoints"
              item-key="id"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{props.item.name}}</td>
                <td class="text-xs-center">{{props.item.description}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveNew">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
 
       
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT ACCESS POINT GROUP</h1>
        </v-toolbar>

         <v-toolbar flat color="white">
        <v-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="basicInformation=true;showAccessPoints=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Basic Information</v-tab>
          <v-tab
            @click="basicInformation=false;showAccessPoints=true"
            class="grey--text"
            flat
            round
            color="grey"
          >Access Points</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat>
        <v-card flat v-show="basicInformation">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.description"
                    label="Description"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

               </v-layout>
            </v-container>
          </v-card-text>
            </v-card>

        <v-card flat v-show="showAccessPoints">
          <v-card-text>
            <v-toolbar flat class="white">
              <v-spacer></v-spacer>
             
              <v-btn  v-if="this.selectedAccessPoints.length==0" 
                class="primary" flat round
                @click="accessPointSearch=true ; selectedAccessPoints=[]"
              >Add Access Points</v-btn>
                   <v-btn v-if="this.selectedAccessPoints.length>0" flat round class="primary" @click="accessPointSearch=true ">Edit Access Points</v-btn>          
            </v-toolbar>
            <v-data-table  v-if="this.selectedAccessPoints.length>0" 
              :headers="headers2"
              :items="selectedAccessPoints"
              item-key="id"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{props.item.name}}</td>
                <td class="text-xs-center">{{props.item.description}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>


          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn v-if="typeof(this.$route.params.tagId) == 'undefined'" color="blue darken-1" flat @click="save" >Save</v-btn>
            <v-btn v-if="typeof(this.$route.params.tagId) != 'undefined'" color="blue darken-1" flat @click="saveTag" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
    <v-data-table v-if="typeof(this.$route.params.tagId) == 'undefined'"
      :headers="headers"
      class="elevation-1"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="accessPointGroups"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
        <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item);basicInformation=true; showAccessPoints=false">edit</v-icon>
            <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.description}}</td>      
    
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
    
    </v-data-table>
     <v-data-table v-if="typeof(this.$route.params.tagId) != 'undefined'"
      :headers="headers"
      class="elevation-1"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="accesspointgroupsinfo"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
        <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item);basicInformation=true; showAccessPoints=false">edit</v-icon>
            <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.description}}</td>      
    
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
    
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import AccessPointSearchModal from "@/components/AccessPointSearchModal.vue";
export default {
  props:["accesspointgroupscomponent",
         "accesspointgroupsinfo"],
 components: {
    accesspointsearchmodal: AccessPointSearchModal
  },
  data() {
    return {
    showAccessPoints: false,
    basicInformation: false,
    selectedAccessPoints: [],
    accessPointSearch: false,
    showDetails: true,
    isloading:true,
    loading: false, 
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Description",
        align: "center",
        value: "description"
      }
    ],
     headers2: [
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Description",
        align: "center",
        value: "description"
      }
    ],
    accessPointGroups: [],
    editedIndex: -1,
    editedItem: {
        name: "",
        description: "",
        isDeleted: false
    },
    defaultItem: {
        name: "",
        description: "",
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
      search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.accessPointGroups= await this.searchAccessPointGroups(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  created() {
    this.initialize();
  },
  methods: {
     routerLinkToDetails(item) { 
      this.editedIndex = this.accessPointGroups.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/accessPointGroupSummary/" + this.editedItem.id });
  
    },
     onAccessPointSelection(e){
      this.selectedAccessPoints = e
      this.accessPointSearch = false
    },
    cancelFields(){
   this.selectedAccessPoints =[],
   this.editedItem.name="",
   this.editedItem.description=""
    },
     searchAccessPointGroups(search){
     let tempAccessPointGroupList = []
       this.isloading =true
      if(search.search!==""){    
        if(typeof(this.$route.params.tagId) == 'undefined'){  
        Api()
        .get('/accessPointGroups/getAllGroupsOnMainPage',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.accessPointGroups=response.data
          this.isloading =false
        })
        } 
      else{
          
        Api()
        .get("/accessPointGroupTags/getAccessPointGroups/" + this.$route.params.tagId,{
          params: {
          search: search.search,
         }
          })
        .then(response => {
          for(let index=0; index< response.data.length; index++){
          tempAccessPointGroupList.push(response.data[index].accessPointGroup);
         }
          this.isloading =false
        });
       this.accesspointgroupsinfo = tempAccessPointGroupList
      }
      }
      this.accessPointGroups = tempAccessPointGroupList
      },
    fetchAccessPointGroups() {
      Api()
        .get("/accessPointGroups/getAllGroupsOnMainPage")
        .then(response => {
          this.accessPointGroups = response.data;
         
        });
    },
    initialize() {
      this.fetchAccessPointGroups();
   
    },
    editItem(item) {
      this.selectedAccessPoints =[]
     // this.editedIndex = this.accessPointGroups.indexOf(item);
      this.editedItem = Object.assign({}, item);
    Api().get('/accessPointAccessPointGroups/getAccessPoints/'+ this.editedItem.id).then(response=> {
       for(let i=0; i<response.data.length; i++){
           this.selectedAccessPoints.push(response.data[i].accessPoint)
         }    
    })   
   
      this.dialog = true;
    },
      deleteItem(id) {
           if (typeof(this.$route.params.tagId) != 'undefined'){
             confirm("Are you sure you want to delete this item?") &&
             Api().get('/accessPointGroupTags/getByGroupAndTag/'+ id +'/'+ this.$route.params.tagId).then(response=>{
              Api().put("/accessPointGroupTags/" + response.data[0].id, {
              isDeleted: true
             })
             
            this.$emit('fetchGroups')
             })
           }else{
             confirm("Are you sure you want to delete this item?") &&
              Api().put("/accessPointGroups/" + id, {
          isDeleted: true
        }).then(response=>{
            this.fetchAccessPointGroups();
        })
           }
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      let tempTagId = this.$route.params.tagId
       let accessPointAccPointGrList=[]
        accessPointAccPointGrList = this.editedItem.accessPointAccessPointGroups
        let accessPointList=[]
      accessPointList = this.selectedAccessPoints
       let accessPointGrId = this.editedItem.id
       let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please enter a name.");
      }
       if (accessPointList.length==0) {
        proceed = false;
        confirm("Please select an access point.");
      }
     if (proceed == true && typeof(this.$route.params.tagId) == 'undefined') {
        Api().put("/accessPointGroups/" + this.editedItem.id, {
          name: this.editedItem.name,
          description: this.editedItem.description,          
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
          console.log('length delted', accessPointAccPointGrList.length)
         for(let m=0; m<accessPointAccPointGrList.length; m++){
            console.log(accessPointAccPointGrList[m].id)
          Api().put("/accessPointAccessPointGroups/" + accessPointAccPointGrList[m].id, {    
          isDeleted: true
          })
          }
        }).then(response=>{  
          console.log('length posted', accessPointList.length)
            for(let n=0; n<accessPointList.length; n++){
              console.log(accessPointList[n].id)
             Api().post("/accessPointAccessPointGroups", {
                   accessPointId: accessPointList[n].id,
                   accessPointGroupId: accessPointGrId
        })
          }           
          this.fetchAccessPointGroups();
        })
        this.close();        
      }
    },
    saveTag(){
      let tempTagId = this.$route.params.tagId
       let accessPointAccPointGrList=[]
        accessPointAccPointGrList = this.editedItem.accessPointAccessPointGroups
        let accessPointList=[]
       accessPointList = this.selectedAccessPoints
       let accessPointGrId = this.editedItem.id
       let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please enter a name.");
      }
       if (accessPointList.length==0) {
        proceed = false;
        confirm("Please select an access point.");
      }
       if (proceed == true && typeof(this.$route.params.tagId) != 'undefined') {
        Api().put("/accessPointGroups/" + this.editedItem.id, {
          name: this.editedItem.name,
          description: this.editedItem.description,          
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
           Api()
        .get("/accessPointAccessPointGroups/getAllByAccessPointGroupId/" + accessPointGrId)
        .then(response=>{
          for(let k=0; k <response.data.length; k++){
           Api().put("/accessPointAccessPointGroups/" + response.data[k].id, {    
          isDeleted: true           
          })}
        })           
          }).then(response=> {
                 for(let index=0; index <accessPointList.length; index++){
              Api().post("/accessPointAccessPointGroups", {
                   accessPointId: accessPointList[index].id,
                   accessPointGroupId: accessPointGrId
        })}           
         this.$emit('fetchGroups')
          })
        
        this.close();
      }
      },
      saveNew() {
      let accessPointList = this.selectedAccessPoints
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please enter a name.");
      }
       if (accessPointList.length==0) {
        proceed = false;
        confirm("Please select an access point.");
      }
      if (proceed == true && typeof(this.$route.params.tagId) == 'undefined') {
        Api().post("/accessPointGroups", {
          name: this.editedItem.name,
          description: this.editedItem.description,          
          isDeleted: this.editedItem.isDeleted  
        }).then(response => {
          let accessPointGrId = response.data.id
          Api().delete('/accessPointAccessPointGroups/deleteByValue')

          for(let index=0; index <accessPointList.length; index++){
              Api().post("/accessPointAccessPointGroups", {
                   accessPointId: accessPointList[index].id,
                   accessPointGroupId: accessPointGrId
        }).then(response => { 
            this.fetchAccessPointGroups()  
        })
          }            
        })       
        this.close();
    }
    if (proceed == true && typeof(this.$route.params.tagId) != 'undefined') {
        Api().post("/accessPointGroups", {
          name: this.editedItem.name,
          description: this.editedItem.description,          
          isDeleted: this.editedItem.isDeleted  
        }).then(response => {
          let accessPointGrId = response.data.id

              Api().post("/accessPointGroupTags", {
                   tagId: this.$route.params.tagId,
                   accessPointGroupId: accessPointGrId
        }).then(response => {  
              for(let i=0; i <accessPointList.length; i++){
              Api().post("/accessPointAccessPointGroups", {
                   accessPointId: accessPointList[i].id,
                   accessPointGroupId: accessPointGrId
        })
             
          } this.$emit('fetchGroups') 
        })         
        })  
        
        this.close();
    }
  }
  }
};
</script>